import FJLocalStore from '../../store/FJLocalStore';
import FJMessageStore from '../../store/FJMessageStore';
import FJUtil from '../../util/FJUtil.js';
import {
    CUSTOM_REMOVE_BG_STEP_LIST,
    ID_LIST,
    setSliceBackgroundPhotoList,
    setSliceBgUsePhotoLoadingList,
    setSliceCurBgColor,
    setSliceCurrentTime,
    setSliceCurSelectBgData,
    setSliceCustomExportProgress,
    setSliceCustomExportStatus,
    setSliceCustomRemoverProgress,
    setSliceCustomRemoverRoughlyAllTime,
    setSliceCustomRemoverStatus,
    setSliceCustomRemoverStep,
    setSliceCustomUploadBgFileList,
    setSliceEditVideoInfo,
    setSliceFlexClipBgLoadStatus,
    setSliceIsPlaying,
    setSliceCustomRemoverIsTrimVideo,
    setSliceTotalTime,
    setSliceTracklets,
    VIDEO_REMOVE_BG_USE_CREDIT,
    setSliceCustomIsUploading,
    setSliceCustomExportFormate,
    setSliceCurMenuIndex,
    setSliceAutoEditVideoInfo,
    setSliceAutoRemoverStatus,
    setSliceAutoEditVideoIsUploading,
    setSliceAutoRemoverProgress,
    setSliceAutoRemoverRoughlyAllTime,
    setSliceAutoProgressThumbnailUrl,
    setSliceCustomProgressThumbnailUrl,
    setSliceAutoExportProgress,
    setSliceAutoExportStatus,
    setSliceAutoRemoverIsTrimVideo,
    setSliceAutoExportFormate,
} from '../slices/FJSliceVideoBgRemover';
import FJCodecStore from '../../store/FJCodecStore';
import FJActionGuide from './FJActionGuide';
import FJImageStore from '../../store/FJImageStore';
import FJConfig from '../../config/FJConfig';
import FJConstant from '../../constants/FJConstant';
import FJActionCommon from './FJActionCommon';
import FJVideoRemoveVideoManageSingleton from '../../store/FJVideoRemove/FJVideoRemoveVideoManage';
import FJS3Config from '../../config/FJS3Config.js';
import FJCompressedImageStore from '../../store/FJCompressedImageStore.js';
import FJVideoRemoveAfterManageSingleton from '../../store/FJVideoRemove/FJVideoRemoveAfterManage.js';
import FJActionModal from './FJActionModal.js';
import FJAppConstant from '../../constants/FJAppConstant.js';
import Download from '../../lib/download';
import { FJVideoRemoveBgDataConfig } from '../../config/dataConfig/FJVideoRemoveBgDataConfig.js';
import FJNetworkStore from '../../store/FJNetworkStore.js';
import _ from 'lodash';
import FJVideoRemoveAutoManageSingleton from '../../store/FJVideoRemove/FJVideoRemoveAutoManage.js';
import { BACKGROUND_TYPE } from '../../store/FJVideoRemove/FJVideoRemoveBaseManage.js';
import { setSliceCreationListAction } from '../slices/FJSliceCommon.js';
import FJLoadLocalforageStore from '../../store/FJLoadLocalforageStore.js';
import FJPoolStore from '../../store/FJPoolStore.js';
import { FJButtonType } from '../../common/components/FJButton/FJButton.jsx';

let _guideModalIndex = 0;
let _intervalId = null;
let _autoRemoveBgIntervalId = null;
let _showGetCreditsModal = false;
let _curEventId = null;
let _autoRemoveBgEventId = null;

let _curAutoRemoverEventId = null;
let _curCustomRemoverEventId = null;

let _customPlayVideoSource = false; // 是否自动播放
let _autoPlayVideoSource = false; // 是否自动播放

let _autoRemoverVideoSource = null; // 自动视频去背景视频
let _autoRemoverFullVideoSource = null; // 自动视频去背景完整视频
let _fullVideoSource = null; // 自定义视频去背景完整视频

const TRIM_VIDEO_DURATION = 5;
const GUID_LIST_DATA = [
    {
        setpNumTitle: 'video-remove-bg-step-1',
        setpTitle: 'video-remove-bg-step-title-1',
        setpContent: 'video-remove-bg-step-content-1',
        skipBtnText: 'skip',
        nextBtnText: 'next',
        arrowDirection: 'bottom',
        relativeDomPosition: {
            x: '50%',
            y: '30%',
        },
        domId: ID_LIST.REMOVE_BG_CANVAS,
    },
    {
        setpNumTitle: 'video-remove-bg-step-2',
        setpTitle: 'video-remove-bg-step-title-2',
        setpContent: 'video-remove-bg-step-content-2',
        skipBtnText: 'skip',
        nextBtnText: 'next',
        relativeDomPosition: {
            x: '22%',
            y: '-202%',
        },
        domId: ID_LIST.REMOVE_BG_CONTROLS,
        isShowDom: true,
        arrowDirection: 'bottom',
    },
    {
        setpNumTitle: 'video-remove-bg-step-3',
        setpTitle: 'video-remove-bg-step-title-3',
        setpContent: 'video-remove-bg-step-content-3',
        nextBtnText: 'got-it',
        relativeDomPosition: {
            x: '148%',
            y: '52%',
        },
        domId: ID_LIST.REMOVE_BG_CUSTOM_GENERATE_BTN,
        isShowDom: true,
    },
];

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
const MAX_VIDEO_SIZE = 500 * 1024 * 1024; // 500MB

// 判断背景图片上传格式
const _judgeFile = (file, type = 'image') => {
    if (type === 'image') {
        // 判断文件大小
        if (file.size > MAX_FILE_SIZE) {
            return {
                status: false,
                errorType: 'max-file',
            };
        }

        // 判断文件类型
        const isImage = file.type.startsWith('image/') && file.type !== 'image/gif';
        if (!isImage) {
            return {
                status: false,
                errorType: 'unsupported-format',
            };
        }

        return {
            status: true,
        };
    } else if (type === 'video') {
        // 判断文件大小
        if (file.size > MAX_VIDEO_SIZE) {
            return {
                status: false,
                errorType: 'max-file',
            };
        }

        // 判断文件是否是 MKV、3GP、mp4，mov、webm、m4v、3g2 格式之一
        const isVideo = FJVideoRemoveBgDataConfig.SUPPORTED_VIDEO_FORMATS.includes(file.type);

        // 对于某些浏览器可能无法正确识别的格式,通过文件扩展名二次检查
        const fileExtension = file.name.split('.').pop().toLowerCase();
        const supportedExtensions = ['mp4', 'webm', 'mkv', '3gp', 'mov', 'm4v', '3g2'];
        const isValidExtension = supportedExtensions.includes(fileExtension);

        if (!isVideo && !isValidExtension) {
            return {
                status: false,
                errorType: 'unsupported-format',
            };
        }

        return {
            status: true,
        };
    }
};

const _showTipByErrorType = (errorType, type = 'image') => {
    switch (errorType) {
        case 'max-file': {
            if (type === 'image') {
                FJMessageStore.addMessage(FJLocalStore._('the-max-image-size-is-xxx-mb').replace('xxx', 10), 'error');
            } else if (type === 'video') {
                FJMessageStore.addMessage(FJLocalStore._('the-max-video-size-is-xxx-mb').replace('xxx', 500), 'error');
            }
            break;
        }

        case 'unsupported-format': {
            if (type === 'image') {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
            } else if (type === 'video') {
                FJMessageStore.addMessage(FJLocalStore._('unsupported-format-video-remove-bg'), 'error');
            }
            break;
        }
    }
};

const _getFileName = () => {
    const now = new Date();
    // 获取年、月、日、时、分、秒
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并补零
    const day = String(now.getDate()).padStart(2, '0'); // 补零
    const hours = String(now.getHours()).padStart(2, '0'); // 补零
    const minutes = String(now.getMinutes()).padStart(2, '0'); // 补零
    const seconds = String(now.getSeconds()).padStart(2, '0'); // 补零

    // 格式化日期和时间为 2024-07-17T111525
    return `Made with FlexClip AI-${year}-${month}-${day}T${hours}${minutes}${seconds}`;
};

// 判断自定义去背景任务是否继续
const _customEventIsContinue = eventId => {
    return eventId === _curCustomRemoverEventId;
};

// 判断自动去背景任务是否继续
const _autoEventIsContinue = eventId => {
    return eventId === _curAutoRemoverEventId;
};

const FJActionVideoRemoveBg = {
    // #region 画布初始化相关
    /**
     * @desc 设置画布
     * @param {HTMLCanvasElement} canvas
     * @returns {Function}
     */
    setCanvasAction: function (canvas) {
        return () => {
            FJVideoRemoveVideoManageSingleton.setCanvas(canvas);
            FJVideoRemoveVideoManageSingleton.draw();
        };
    },

    /**
     * @desc 设置视频缩略图画布
     * @param {HTMLCanvasElement} canvas
     * @returns {Function}
     */
    setVideoThumbnailCanvasAction: function (canvas) {
        return async dispatch => {
            FJVideoRemoveVideoManageSingleton.setVideoThumbnailCanvas(canvas);
            await dispatch(this.updateVideoThumbnailAction());
        };
    },

    /**
     * @desc 初始化自定义删除背景第二步的 canvas
     * @param {Object} canvas
     * @returns {Function}
     */
    initCustomRemoverStep2CanvasAction: function (canvas) {
        return async dispatch => {
            FJVideoRemoveAfterManageSingleton.setCanvas(canvas);
            FJVideoRemoveAfterManageSingleton.draw();
            setTimeout(() => {
                _customPlayVideoSource && dispatch(this.playAction());
                _customPlayVideoSource = false;
            }, 20);
        };
    },

    /**
     * @desc 设置自定义对象已选中预览画布
     * @param {HTMLCanvasElement} canvas
     * @returns {Function}
     */
    setCustomObjectPreviewCanvasAction: function (canvas) {
        return () => {
            FJVideoRemoveVideoManageSingleton.setCustomObjectPreviewCanvas(canvas);
        };
    },

    /**
     * @desc 设置自动删除背景画布
     * @param {HTMLCanvasElement} canvas
     * @returns {Function}
     */
    setAutoRemoveBgCanvasAction: function (canvas) {
        return async dispatch => {
            FJVideoRemoveAutoManageSingleton.setCanvas(canvas);
            FJVideoRemoveAutoManageSingleton.draw();
            setTimeout(() => {
                _autoPlayVideoSource && dispatch(this.playAction());
                _autoPlayVideoSource = false;
            }, 20);
        };
    },

    /**
     * @desc 更新视频缩略图
     * @returns {Function}
     */
    updateVideoThumbnailAction: function () {
        return async (dispatch, getState) => {
            const customRemoverStep = getState().videoBgRemover.customRemoverStep;
            if (customRemoverStep === 0) {
                if (!this._throttleUpdateVideoThumbnail) {
                    this._throttleUpdateVideoThumbnail = _.throttle(() => {
                        FJVideoRemoveVideoManageSingleton.updateVideoThumbnail()
                            .then(() => {})
                            .catch(() => {});
                    }, 400);
                }
                this._throttleUpdateVideoThumbnail();
            }
        };
    },
    // #endregion

    /**
     * @desc 上传视频
     * @param {File} source
     * @returns {Function}
     */
    uploadCustomVideoAction: function (source) {
        return async (dispatch, getState) => {
            const customIsUploading = getState().videoBgRemover.customIsUploading;
            if (customIsUploading) return;

            dispatch(this.exportGoBackAction(true));
            dispatch(setSliceCustomIsUploading(true));
            dispatch(this.pauseAction());
            dispatch(setSliceCustomRemoverIsTrimVideo(false));

            const videoJudge = _judgeFile(source, 'video');
            if (!videoJudge.status) {
                _showTipByErrorType(videoJudge.errorType, 'video');
                dispatch(setSliceCustomIsUploading(false));
                return;
            }

            const videoMetadata = await new Promise(resolve => {
                const videoElement = document.createElement('video');
                videoElement.addEventListener('loadedmetadata', () => {
                    const result = {
                        duration: videoElement.duration,
                        width: videoElement.videoWidth,
                        height: videoElement.videoHeight,
                    };
                    videoElement.remove();
                    resolve(result);
                });
                videoElement.addEventListener('error', () => {
                    resolve(null);
                });
                videoElement.src = URL.createObjectURL(source);
            });

            if (!videoMetadata || videoMetadata.width === 0 || videoMetadata.height === 0) {
                FJMessageStore.addMessage(
                    FJLocalStore._('this-video-needs-to-be-transcoded-please-upload-another-video'),
                    'error',
                );
                dispatch(setSliceCustomIsUploading(false));
                return;
            }

            if (videoMetadata.duration >= 60 * 3 + 1) {
                FJMessageStore.addMessage(
                    FJLocalStore._('the-video-length-should-be-shorter-than-xxx-minutes').replace('xxx', 3),
                    'error',
                );
                dispatch(setSliceCustomIsUploading(false));
                return;
            }

            const sourceInfo = {
                width: videoMetadata.width,
                height: videoMetadata.height,
                duration: videoMetadata.duration,
            };
            let isFree = false;
            const __judgeCanGenerate = async () => {
                // 登录判断
                const userSpaceType = await FJUtil.checkUserSpace({
                    errorCallback: () => {
                        FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
                    },
                });
                if (userSpaceType > 0) {
                    return;
                }
                // 额度判断
                const { creditNumber } = getState().common;
                const { videoBackgroundRemoveFreeNum } = getState().videoBgRemover;
                const canCredit = creditNumber >= Math.floor(sourceInfo.duration) * VIDEO_REMOVE_BG_USE_CREDIT;
                const useFree = !canCredit && videoBackgroundRemoveFreeNum > 0;
                isFree = useFree;
                return true;
            };

            const canGenerate = await __judgeCanGenerate();
            if (!canGenerate && !FJUtil.isLocalhost()) {
                dispatch(setSliceCustomIsUploading(false));
                return;
            }

            const __showGuideModal = () => {
                const __skipCallback = () => {
                    localStorage.setItem('guideModalShown', 'true');
                    dispatch(FJActionGuide.hideGuideModalAction());
                };

                const __nextCallback = () => {
                    _guideModalIndex++;

                    if (_guideModalIndex >= GUID_LIST_DATA.length) {
                        dispatch(FJActionGuide.hideGuideModalAction());
                        _guideModalIndex = 0;
                        localStorage.setItem('guideModalShown', 'true');
                        return;
                    }
                    __showGuideModal();
                };

                const guideModalShown = localStorage.getItem('guideModalShown');
                if (guideModalShown) {
                    return;
                }

                dispatch(
                    FJActionGuide.showGuideModalAction({
                        ...GUID_LIST_DATA[_guideModalIndex],
                        skipBtnCallback: __skipCallback,
                        nextBtnCallback: __nextCallback,
                    }),
                );
            };

            try {
                // 保存完整视频源
                _fullVideoSource = {
                    source: source,
                    duration: videoMetadata.duration,
                };
                dispatch(setSliceCustomExportStatus(FJConstant.DEFAULT));
                dispatch(this.setCustomRemoverStepAction(CUSTOM_REMOVE_BG_STEP_LIST[0], false));

                let isTrimVideo = false;
                const trimVideoSource = await new Promise((resolve, reject) => {
                    const __trimVideoComplete = blob => {
                        isTrimVideo = true;
                        dispatch(setSliceCustomRemoverIsTrimVideo(true));
                        resolve(new File([blob], 'video.mp4', { type: 'video/mp4' }));
                    };
                    const __trimVideoError = () => {
                        console.log('裁剪视频失败');
                        reject();
                    };
                    if (isFree && videoMetadata.duration >= 6) {
                        FJCodecStore.trimVideoAndExport(source, {
                            start: 0,
                            end: TRIM_VIDEO_DURATION,
                            onComplete: __trimVideoComplete,
                            onError: __trimVideoError,
                        });
                    } else {
                        resolve(source);
                    }
                });

                // 免费用户裁剪视频时长为 5 秒
                const editDuration = isTrimVideo ? TRIM_VIDEO_DURATION : videoMetadata.duration;

                dispatch(FJActionCommon.setHeaderTabIndexAction(0));
                FJVideoRemoveVideoManageSingleton.clearAll();
                FJVideoRemoveVideoManageSingleton.setAllFrameCount(editDuration);
                await FJVideoRemoveVideoManageSingleton.setSource(trimVideoSource);
                dispatch(setSliceCustomRemoverStatus(FJConstant.DEFAULT));

                dispatch(setSliceTotalTime(editDuration));
                dispatch(
                    setSliceEditVideoInfo({
                        width: sourceInfo.width,
                        height: sourceInfo.height,
                        duration: editDuration,
                    }),
                );
                // TODO : 不使用 this.seekAction(0) 而是使用 FJVideoRemoveVideoManageSingleton.seek(0)
                // 防止这个时候在自动去背景而导致 seek 没有执行 导致后续界面渲染空白
                FJVideoRemoveVideoManageSingleton.seek(0);
                dispatch(setSliceCurrentTime(0));
                dispatch(this._updateTrackletsByCoreData());
                dispatch(this.updateVideoThumbnailAction());
                setTimeout(() => {
                    __showGuideModal();
                }, 200);
            } catch (e) {
                console.log(e);
            } finally {
                dispatch(setSliceCustomIsUploading(false));
            }
        };
    },

    /**
     * @desc 上传自动编辑视频
     * @param {File} source
     * @returns {Function}
     */
    uploadAutoEditVideoAction: function (source) {
        return async (dispatch, getState) => {
            dispatch(setSliceAutoEditVideoIsUploading(true));
            dispatch(this.autoExportGoBackAction());

            _curAutoRemoverEventId = `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
            let curEventID = _curAutoRemoverEventId;
            _autoRemoverVideoSource = source;
            _autoRemoverFullVideoSource = source;
            const videoJudge = _judgeFile(source, 'video');
            if (!videoJudge.status) {
                _showTipByErrorType(videoJudge.errorType, 'video');
                dispatch(setSliceAutoEditVideoIsUploading(false));
                return;
            }

            const videoElement = document.createElement('video');
            const videoMetadata = await new Promise(resolve => {
                videoElement.addEventListener('loadedmetadata', () => {
                    const result = {
                        duration: videoElement.duration,
                        width: videoElement.videoWidth,
                        height: videoElement.videoHeight,
                    };
                    videoElement.remove();
                    resolve(result);
                });
                videoElement.addEventListener('error', () => {
                    resolve(null);
                });
                videoElement.src = URL.createObjectURL(source);
            });

            if (!videoMetadata || videoMetadata.width === 0 || videoMetadata.height === 0) {
                FJMessageStore.addMessage(
                    FJLocalStore._('this-video-needs-to-be-transcoded-please-upload-another-video'),
                    'error',
                );
                dispatch(setSliceAutoEditVideoIsUploading(false));
                return;
            }

            if (videoMetadata.duration >= 60 * 3 + 1) {
                FJMessageStore.addMessage(
                    FJLocalStore._('the-video-length-should-be-shorter-than-xxx-minutes').replace('xxx', 3),
                    'error',
                );
                dispatch(setSliceAutoEditVideoIsUploading(false));
                return;
            }

            if (FJUtil.isLocalhost()) {
                dispatch(setSliceAutoEditVideoIsUploading(false));
                const url = URL.createObjectURL(source);
                await FJVideoRemoveAutoManageSingleton.setSource(url);

                dispatch(setSliceAutoRemoverStatus(FJConstant.SUCCESS));
                dispatch(setSliceTotalTime(videoMetadata.duration));
                dispatch(
                    setSliceAutoEditVideoInfo({
                        source: source,
                        width: videoMetadata.width,
                        height: videoMetadata.height,
                    }),
                );
                return;
            }

            const __cancelCallback = () => {
                const editVideoInfo = FJVideoRemoveAutoManageSingleton.getSourceInfo();
                if (editVideoInfo) {
                    dispatch(setSliceTotalTime(editVideoInfo.duration));
                    dispatch(
                        setSliceAutoEditVideoInfo({
                            width: editVideoInfo.width,
                            height: editVideoInfo.height,
                        }),
                    );
                }

                dispatch(setSliceAutoRemoverStatus(editVideoInfo ? FJConstant.SUCCESS : FJConstant.DEFAULT));
            };

            const __errorCallback = () => {
                dispatch(setSliceAutoRemoverStatus(FJConstant.ERROR));
                dispatch(setSliceAutoEditVideoIsUploading(false));
                dispatch(this._endAutoRemoverProgress(false));
            };

            const __successCallback = async dataList => {
                dispatch(this.removeBgAction());
                const data = dataList[0];
                await FJVideoRemoveAutoManageSingleton.setSource(data.videoUrl);
                FJVideoRemoveAutoManageSingleton.seek(0);
                dispatch(setSliceAutoRemoverStatus(FJConstant.SUCCESS));
                dispatch(this._endAutoRemoverProgress());
                _autoPlayVideoSource = true;
                dispatch(
                    setSliceAutoEditVideoInfo({
                        width: videoMetadata.width,
                        height: videoMetadata.height,
                    }),
                );
                dispatch(this._updateCommonData());
            };

            // 创建缩略图
            const __createThumbnail = async () => {
                await new Promise(resolve => {
                    videoElement.addEventListener('seeked', () => {
                        resolve();
                    });
                    videoElement.addEventListener('error', () => {
                        resolve();
                    });
                    videoElement.currentTime = 0;
                });

                // 设置自动去背景缩略图
                const canvas = FJPoolStore.getCanvas('2d');
                const ctx = canvas.getContext('2d');
                canvas.width = videoElement.videoWidth;
                canvas.height = videoElement.videoHeight;
                ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
                const src = canvas.toDataURL('image/png');
                dispatch(setSliceAutoProgressThumbnailUrl(src));
                FJPoolStore.releaseCanvas(canvas);
            };

            let isFree = false;
            const __judgeCanGenerate = async () => {
                // 登录判断
                const userSpaceType = await FJUtil.checkUserSpace({
                    errorCallback: () => {
                        FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
                    },
                });
                if (userSpaceType > 0) {
                    return;
                }
                // 额度判断
                const { creditNumber } = getState().common;
                const { videoAutoBackgroundRemoveFreeNum } = getState().videoBgRemover;
                const canCredit = creditNumber >= Math.floor(videoMetadata.duration) * VIDEO_REMOVE_BG_USE_CREDIT;
                const useFree = !canCredit && videoAutoBackgroundRemoveFreeNum > 0;
                isFree = useFree;

                if (!canCredit && !useFree) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    return false;
                }
                return true;
            };

            const canGenerate = await __judgeCanGenerate();
            if (!canGenerate && !FJUtil.isLocalhost()) {
                dispatch(setSliceAutoEditVideoIsUploading(false));
                return;
            }

            if (!_autoEventIsContinue(curEventID)) {
                _curAutoRemoverEventId === null && __cancelCallback();
                return;
            }

            try {
                let isTrimVideo = false;

                const trimVideoSource = await new Promise((resolve, reject) => {
                    const __trimVideoComplete = blob => {
                        isTrimVideo = true;
                        resolve(new File([blob], 'video.mp4', { type: 'video/mp4' }));
                    };
                    const __trimVideoError = () => {
                        console.log('裁剪视频失败');
                        reject();
                    };
                    if (isFree && videoMetadata.duration >= 6) {
                        FJCodecStore.trimVideoAndExport(source, {
                            start: 0,
                            end: TRIM_VIDEO_DURATION,
                            onComplete: __trimVideoComplete,
                            onError: __trimVideoError,
                        });
                    } else {
                        resolve(source);
                    }
                });
                _autoRemoverVideoSource = trimVideoSource;
                // 免费用户裁剪视频时长为 5 秒
                const editDuration = isTrimVideo ? TRIM_VIDEO_DURATION : videoMetadata.duration;
                dispatch(setSliceTotalTime(editDuration));
                const key = await FJUtil.hashEncode(trimVideoSource);
                if (!key) {
                    __errorCallback();
                    return;
                }

                if (!_autoEventIsContinue(curEventID)) {
                    _curAutoRemoverEventId === null && __cancelCallback();
                    return;
                }

                dispatch(FJActionCommon.setHeaderTabIndexAction(0));
                dispatch(setSliceAutoRemoverIsTrimVideo(isTrimVideo));
                dispatch(setSliceAutoProgressThumbnailUrl(null));
                __createThumbnail();

                dispatch(
                    setSliceAutoEditVideoInfo({
                        width: videoMetadata.width,
                        height: videoMetadata.height,
                    }),
                );
                dispatch(setSliceAutoRemoverProgress(0));
                dispatch(setSliceAutoRemoverRoughlyAllTime(editDuration * 8));
                dispatch(setSliceAutoEditVideoIsUploading(false));
                dispatch(setSliceAutoRemoverStatus(FJConstant.START));

                if (!_autoEventIsContinue(curEventID)) {
                    _curAutoRemoverEventId === null && __cancelCallback();
                    return;
                }

                const fileExtension = trimVideoSource.name.split('.').pop();
                const s3Url = FJConfig.originalImageKey + `${key}.${fileExtension}`;

                const s3Res = await FJImageStore.upLoadFileToS3Async(trimVideoSource, s3Url);
                if (!s3Res) {
                    __errorCallback();
                    return;
                }

                if (!_autoEventIsContinue(curEventID)) {
                    _curAutoRemoverEventId === null && __cancelCallback();
                    return;
                }

                const res = await FJNetworkStore.autoVideoRemoveBackground({
                    url: FJS3Config.S3_SERVER_HOST + s3Url,
                    duration: editDuration,
                });

                if (!res) {
                    __errorCallback();
                    return;
                }
                _autoRemoveBgEventId = res.event_id;

                const tool = FJUtil.getToolName();
                FJUtil.eaLog('ai tool start generating', {
                    'credit&free': isFree ? 'free' : 'credit',
                    tool,
                });

                if (!_autoEventIsContinue(curEventID)) {
                    dispatch(this.cancelTaskAction(_autoRemoveBgEventId));
                    _autoRemoveBgEventId = null;
                    _curAutoRemoverEventId === null && __cancelCallback();
                    return;
                }

                dispatch(FJActionCommon.updateFreezeInfoAction());

                dispatch(this._startAutoRemoverProgress());
                dispatch(setSliceAutoRemoverStatus(FJConstant.GENERATING));

                if (_autoRemoveBgEventId) {
                    // 3. 轮询任务状态
                    const __callback = data => {
                        const { type, waitingEndTime } = data;

                        if (type === FJConstant.SUCCESS) {
                            const finishTaskCreationList = data.finishTaskCreationList;
                            __successCallback(finishTaskCreationList);

                            let _endTime = new Date().getTime();
                            const generatingDuration = FJUtil.getTimeDiff(waitingEndTime, _endTime);

                            FJUtil.eaLog('ai video bg remover success', {
                                'generating duration': generatingDuration,
                                type: 'auto',
                                'credit&free': isFree ? 'free' : 'credit',
                                'video duration': FJUtil.getTimeDiff(0, editDuration * 1000),
                            });

                            FJUtil.eaLog('ai tool generate success', {
                                tool: FJUtil.getToolName(),
                                'credit&free': isFree ? 'free' : 'credit',
                            });
                        }

                        if (type === FJConstant.ERROR) {
                            __errorCallback();
                        }
                    };

                    dispatch(
                        FJActionCommon.pollingTaskAction([_autoRemoveBgEventId], {
                            callback: __callback,
                        }),
                    );
                }
            } catch (e) {
                __errorCallback();
            }
        };
    },

    /**
     * @desc 更新是否正在播放
     * @returns {Function}
     */
    _updateIsPlayingAction: function () {
        return async (dispatch, getState) => {
            const customRemoverStep = getState().videoBgRemover.customRemoverStep;
            const curMenuIndex = getState().videoBgRemover.curMenuIndex;

            let isPlaying = false;

            if (curMenuIndex === 1) {
                isPlaying =
                    customRemoverStep === 1
                        ? FJVideoRemoveAfterManageSingleton.getIsPlaying()
                        : FJVideoRemoveVideoManageSingleton.getIsPlaying();
            } else {
                isPlaying = FJVideoRemoveAutoManageSingleton.getIsPlaying();
            }
            dispatch(setSliceIsPlaying(isPlaying));
        };
    },

    /**
     * @desc 跳转到指定帧
     * @param {Number} time
     * @returns {Function}
     */
    seekAction: function (time, model) {
        return async (dispatch, getState) => {
            const curMenuIndex = getState().videoBgRemover.curMenuIndex;
            if ((model === 'custom' && curMenuIndex !== 1) || (model === 'auto' && curMenuIndex !== 0)) {
                return;
            }
            await dispatch(this.pauseAction());
            const isPlaying = getState().videoBgRemover.isPlaying;
            const customRemoverStep = getState().videoBgRemover.customRemoverStep;

            if (curMenuIndex === 1) {
                if (customRemoverStep === 1) {
                    FJVideoRemoveAfterManageSingleton.seek(time);
                    isPlaying && dispatch(this.playAction());
                } else {
                    FJVideoRemoveVideoManageSingleton.seek(time);
                }
            } else {
                FJVideoRemoveAutoManageSingleton.seek(time);
                isPlaying && dispatch(this.playAction());
            }

            dispatch(setSliceCurrentTime(time));
        };
    },

    /**
     * @desc 播放视频
     * @returns {Function}
     */
    playAction: function () {
        return async (dispatch, getState) => {
            const customRemoverStep = getState().videoBgRemover.customRemoverStep;
            const curMenuIndex = getState().videoBgRemover.curMenuIndex;

            const __playingCallback = currentTime => {
                dispatch(setSliceCurrentTime(currentTime));
            };
            const __pauseCallback = () => {
                dispatch(this.seekAction(0));
                dispatch(this._updateIsPlayingAction());
            };

            if (curMenuIndex === 1) {
                if (customRemoverStep === 1) {
                    await FJVideoRemoveAfterManageSingleton.play(__playingCallback, __pauseCallback);
                } else {
                    await FJVideoRemoveVideoManageSingleton.play(__playingCallback, __pauseCallback);
                }
            } else {
                await FJVideoRemoveAutoManageSingleton.play(__playingCallback, __pauseCallback);
            }

            dispatch(this._updateIsPlayingAction());
        };
    },

    /**
     * @desc 暂停视频
     * @returns {Function}
     */
    pauseAction: function () {
        return async (dispatch, getState) => {
            const customRemoverStep = getState().videoBgRemover.customRemoverStep;
            const curMenuIndex = getState().videoBgRemover.curMenuIndex;

            if (curMenuIndex === 1) {
                if (customRemoverStep === 1) {
                    await FJVideoRemoveAfterManageSingleton.pause();
                } else {
                    await FJVideoRemoveVideoManageSingleton.pause();
                    // 添加一个小延时以确保视频真正暂停
                    await new Promise(resolve => setTimeout(resolve, 50));
                    const currentTime = FJVideoRemoveVideoManageSingleton.getCurrentTime();
                    dispatch(setSliceCurrentTime(currentTime));
                }
            } else {
                await FJVideoRemoveAutoManageSingleton.pause();
            }

            dispatch(this._updateIsPlayingAction());
        };
    },

    /**
     * @desc 设置音量
     * @param {Number} volume
     * @returns {Function}
     */
    setVolumeAction: function (volume) {
        return async (dispatch, getState) => {
            const customRemoverStep = getState().videoBgRemover.customRemoverStep;
            const curMenuIndex = getState().videoBgRemover.curMenuIndex;
            if (curMenuIndex === 1) {
                if (customRemoverStep === 1) {
                    FJVideoRemoveAfterManageSingleton.setVolume(volume);
                } else {
                    FJVideoRemoveVideoManageSingleton.setVolume(volume);
                }
            } else {
                FJVideoRemoveAutoManageSingleton.setVolume(volume);
            }
        };
    },

    /**
     * @desc 添加点
     * @param {Object} point
     * @returns {Function}
     */
    addPointAction: function (point) {
        return async (dispatch, getState) => {
            const isPlaying = getState().videoBgRemover.isPlaying;

            if (isPlaying) {
                await dispatch(this.pauseAction());
                return;
            }

            const tracklets = getState().videoBgRemover.tracklets;
            // 获取当前视频时间
            const currentTime = FJVideoRemoveVideoManageSingleton.getCurrentTime();

            const currentPoints = tracklets[0].points;

            let nextPoints = [...currentPoints];
            const isSameTime = FJUtil.compareTimes(currentTime, tracklets[0].currentTime);
            if (isSameTime) {
                nextPoints.push([point.x, point.y, 1]);
            } else {
                nextPoints = [[point.x, point.y, 1]];
            }

            const __callback = () => {
                dispatch(this.seekAction(currentTime, 'custom'));
                dispatch(this._updateTrackletsByCoreData());
                FJVideoRemoveVideoManageSingleton.updateCustomObjectPreviewCanvas();
            };

            const __failCallBack = error => {
                const tracklets = FJVideoRemoveVideoManageSingleton.getTracklets();

                if (error.message === 'not login') {
                    FJUtil.login();
                    dispatch(setSliceTracklets([...tracklets]));
                    FJMessageStore.addMessage(FJLocalStore._('login-has-expired-please-login-again'), 'error');
                    return;
                }
                // 添加点失败，将点失败状态添加到 reducer 中  核心库中不存在失败点
                // dispatch(this._updateTrackletsByCoreData());
                // 从核心库中获取轨迹对象 失败时会清空一些数据
                dispatch(
                    setSliceTracklets([
                        {
                            ...tracklets[0],
                            currentTime,
                            points: isSameTime ? [...currentPoints, [point.x, point.y, 2]] : [[point.x, point.y, 2]],
                        },
                    ]),
                );
            };

            try {
                // 添加加载状态
                dispatch(
                    setSliceTracklets([
                        {
                            ...tracklets[0],
                            currentTime,
                            points: isSameTime ? [...currentPoints, [point.x, point.y, 4]] : [[point.x, point.y, 4]],
                        },
                    ]),
                );
                await FJVideoRemoveVideoManageSingleton.updatePoints(nextPoints, __callback, __failCallBack);
            } catch (error) {
                __failCallBack();
            }
        };
    },

    /**
     * @desc 删除点
     * @param {Number} index
     * @returns {Function}
     */
    deletePointAction: function (index) {
        return async (dispatch, getState) => {
            const tracklets = getState().videoBgRemover.tracklets;
            const currentTime = getState().videoBgRemover.currentTime;
            const currentPoints = tracklets[0].points;
            const nextPoints = [...currentPoints];
            nextPoints.splice(index, 1);

            // 如果删除后没有点，则删除所有点
            if (nextPoints.length === 0) {
                dispatch(this.deleteAllPointAction());
                return;
            }

            // 如果删除后没有成功的点，则删除所有点 保留reducer 中的失败点
            const postPointsData = nextPoints.filter(point => point[2] === 1);
            if (postPointsData.length === 0) {
                FJVideoRemoveVideoManageSingleton.deleteAllPoints();
                FJVideoRemoveVideoManageSingleton.draw();
                FJVideoRemoveVideoManageSingleton.updateCustomObjectPreviewCanvas();

                dispatch(
                    setSliceTracklets([
                        {
                            ...tracklets[0],
                            masks: [],
                            currentTime: currentTime,
                            points: nextPoints,
                        },
                    ]),
                );
                return;
            }

            const __callback = () => {
                FJVideoRemoveVideoManageSingleton.draw();
                dispatch(this._updateTrackletsByCoreData());
                FJVideoRemoveVideoManageSingleton.updateCustomObjectPreviewCanvas();
            };

            const __failCallBack = error => {
                const tracklets = FJVideoRemoveVideoManageSingleton.getTracklets();

                if (error.message === 'not login') {
                    FJUtil.login();
                    dispatch(setSliceTracklets([...tracklets]));
                    FJMessageStore.addMessage(FJLocalStore._('login-has-expired-please-login-again'), 'error');
                    return;
                }

                // 删除点失败，将点失败状态添加到 reducer 中  删除点失败 点状态为 1
                dispatch(
                    setSliceTracklets([
                        {
                            ...tracklets[0],
                            currentTime: currentTime,
                            points: [...nextPoints, [currentPoints[index][0], currentPoints[index][1], 1]],
                        },
                    ]),
                );
                FJMessageStore.addMessage(FJLocalStore._('failed-to-cancel-please-try-again'), 'error');
            };

            try {
                // 添加加载状态
                const newPoints = FJUtil.deepClone(currentPoints);
                newPoints[index][2] = 4;
                dispatch(
                    setSliceTracklets([
                        {
                            ...tracklets[0],
                            currentTime: currentTime,
                            points: newPoints,
                        },
                    ]),
                );
                await FJVideoRemoveVideoManageSingleton.updatePoints(nextPoints, __callback, __failCallBack);
            } catch (error) {
                __failCallBack();
            }
        };
    },

    /**
     * @desc 删除错误点
     * @param {Number} index
     * @returns {Function}
     */
    deleteErrorPointAction: function (index) {
        return async (dispatch, getState) => {
            const tracklets = getState().videoBgRemover.tracklets;
            const currentPoints = tracklets[0].points;
            const nextPoints = FJUtil.deepClone(currentPoints);

            nextPoints.splice(index, 1);

            dispatch(
                setSliceTracklets([
                    {
                        ...tracklets[0],
                        points: nextPoints,
                    },
                ]),
            );
        };
    },

    /**
     * @desc 重试添加点
     * @param {Number} index
     * @returns {Function}
     */
    retryAddPointAction: function (index) {
        return async (dispatch, getState) => {
            const tracklets = getState().videoBgRemover.tracklets;
            const currentPoints = tracklets[0].points;
            const nextPoints = FJUtil.deepClone(currentPoints);

            // 全部重试
            nextPoints.forEach(point => {
                if (point[2] === 3) {
                    nextPoints.splice(index, 1);
                } else {
                    point[2] = 1;
                }
            });

            const __callback = () => {
                FJVideoRemoveVideoManageSingleton.draw();
                dispatch(this._updateTrackletsByCoreData());
                FJVideoRemoveVideoManageSingleton.updateCustomObjectPreviewCanvas();
            };

            const __failCallBack = error => {
                const tracklets = FJVideoRemoveVideoManageSingleton.getTracklets();

                if (error.message === 'not login') {
                    FJUtil.login();
                    dispatch(setSliceTracklets([...tracklets]));
                    FJMessageStore.addMessage(FJLocalStore._('login-has-expired-please-login-again'), 'error');
                    return;
                }

                // 重试添加点失败，将点失败状态添加到 reducer 中  核心库中不存在失败点  重试添加失败点状态为
                dispatch(
                    setSliceTracklets([
                        {
                            ...tracklets[0],
                            points: [...currentPoints],
                        },
                    ]),
                );
                FJMessageStore.addMessage(FJLocalStore._('failed-to-retry-please-try-again'), 'error');
            };

            try {
                // 添加加载状态
                const newPoints = FJUtil.deepClone(currentPoints);
                // 全部重试
                newPoints.forEach(point => {
                    if (point[2] === 3 || point[2] === 2) {
                        point[2] = 4;
                    }
                });
                // newPoints[index][2] = 4;
                dispatch(
                    setSliceTracklets([
                        {
                            ...tracklets[0],
                            points: newPoints,
                        },
                    ]),
                );
                await FJVideoRemoveVideoManageSingleton.updatePoints(nextPoints, __callback, __failCallBack);
            } catch (error) {
                __failCallBack();
            }
        };
    },

    /**
     * @desc 删除所有点
     * @returns {Function}
     */
    deleteAllPointAction: function () {
        return async dispatch => {
            FJVideoRemoveVideoManageSingleton.deleteAllPoints();
            FJVideoRemoveVideoManageSingleton.draw();
            dispatch(this._updateTrackletsByCoreData());
            FJVideoRemoveVideoManageSingleton.updateCustomObjectPreviewCanvas();
        };
    },

    /**
     * @desc 开始自定义去背景进度
     * @returns {Function}
     */
    _startCustomRemoverProgress: function (startProgress = 0) {
        return async (dispatch, getState) => {
            dispatch(setSliceCustomRemoverProgress(startProgress));
            const allTime = getState().videoBgRemover.customRemoverRoughlyAllTime;

            let requestAnimationTime;
            const __addProgress = timestamp => {
                if (!requestAnimationTime) requestAnimationTime = timestamp;

                const progress = Math.min((timestamp - requestAnimationTime) / 1000 + startProgress, allTime);
                dispatch(setSliceCustomRemoverProgress(Math.min((progress / allTime) * 100, 99)));

                if (progress === allTime && _intervalId) {
                    window.cancelAnimationFrame(_intervalId);
                    return;
                } else {
                    if (_intervalId) {
                        _intervalId = window.requestAnimationFrame(__addProgress);
                    }
                }
            };

            if (_intervalId) window.cancelAnimationFrame(_intervalId);
            _intervalId = window.requestAnimationFrame(__addProgress);
        };
    },

    /**
     * @desc 结束自定义去背景进度
     * @returns {Function}
     */
    _endCustomRemoverProgress: function (isUpdateProgress = true) {
        return async dispatch => {
            if (_intervalId) {
                window.cancelAnimationFrame(_intervalId);
                _intervalId = null;
            }
            if (isUpdateProgress) {
                dispatch(setSliceCustomRemoverProgress(100));
            }
        };
    },

    /**
     * @desc 开始自动去背景进度
     * @returns {Function}
     */
    _startAutoRemoverProgress: function (startProgress = 0) {
        return async (dispatch, getState) => {
            dispatch(setSliceAutoRemoverProgress(startProgress));
            const allTime = getState().videoBgRemover.autoRemoverRoughlyAllTime;

            dispatch(setSliceAutoRemoverRoughlyAllTime(allTime));

            let requestAnimationTime;
            const __addProgress = timestamp => {
                if (!requestAnimationTime) requestAnimationTime = timestamp;

                const progress = Math.min((timestamp - requestAnimationTime) / 1000 + startProgress, allTime);
                dispatch(setSliceAutoRemoverProgress(Math.min((progress / allTime) * 100, 99)));

                if (progress === allTime && _autoRemoveBgIntervalId) {
                    window.cancelAnimationFrame(_autoRemoveBgIntervalId);
                    return;
                } else {
                    if (_autoRemoveBgIntervalId) {
                        _autoRemoveBgIntervalId = window.requestAnimationFrame(__addProgress);
                    }
                }
            };

            if (_autoRemoveBgIntervalId) window.cancelAnimationFrame(_autoRemoveBgIntervalId);
            _autoRemoveBgIntervalId = window.requestAnimationFrame(__addProgress);
        };
    },

    /**
     * @desc 结束自动去背景进度
     * @returns {Function}
     */
    _endAutoRemoverProgress: function (isUpdateProgress = true) {
        return async dispatch => {
            if (_autoRemoveBgIntervalId) {
                window.cancelAnimationFrame(_autoRemoveBgIntervalId);
                _autoRemoveBgIntervalId = null;
            }
            if (isUpdateProgress) {
                dispatch(setSliceAutoRemoverProgress(100));
            }
        };
    },

    /**
     * @desc 开始跟踪
     * @returns {Function}
     */
    startTrackAction: function () {
        return async (dispatch, getState) => {
            if (FJUtil.isLocalhost()) {
                const file = FJVideoRemoveVideoManageSingleton.getSource();
                const src = URL.createObjectURL(file);
                await FJVideoRemoveAfterManageSingleton.setSource(src);
                dispatch(this.setCustomRemoverStepAction(CUSTOM_REMOVE_BG_STEP_LIST[1]));
                // dispatch(setSliceCustomRemoverStatus(FJConstant.START));
                // dispatch(this._startCustomRemoverProgress());
                return;
            }
            const __websocketCallback = async data => {
                console.log(data);
            };

            const __errorCallback = () => {
                dispatch(this.setCustomRemoverStepAction(CUSTOM_REMOVE_BG_STEP_LIST[0]));
                dispatch(setSliceCustomRemoverStatus(FJConstant.ERROR));
                dispatch(this._endCustomRemoverProgress(false));
            };

            const __successCallback = async finishTaskCreationList => {
                const item = finishTaskCreationList[0];

                // 上传视频缩略图
                dispatch(FJActionCommon.setHeaderTabIndexAction(0));
                await FJVideoRemoveAfterManageSingleton.setSource(item.videoUrl);
                dispatch(this.setCustomRemoverStepAction(CUSTOM_REMOVE_BG_STEP_LIST[1]));
                dispatch(setSliceCustomRemoverStatus(FJConstant.DEFAULT));
                dispatch(this._endCustomRemoverProgress());
                dispatch(this._updateCommonData());
                _customPlayVideoSource = true;
            };

            const __cancelCallback = () => {
                dispatch(setSliceCustomRemoverStatus(FJConstant.DEFAULT));
            };

            const __createThumbnail = async () => {
                const src = await FJVideoRemoveVideoManageSingleton.getOriginalThumbnailUrl();
                dispatch(setSliceCustomProgressThumbnailUrl(src));
            };

            const customIsTrimVideo = getState().videoBgRemover.customRemoverIsTrimVideo;

            if (customIsTrimVideo) {
                FJUtil.eaLog('ai video custom remove 5s click');
            }

            dispatch(this.pauseAction());
            dispatch(FJActionCommon.setHeaderTabIndexAction(0));
            const tracklets = getState().videoBgRemover.tracklets;
            const hasPoint = tracklets[0].points.some(point => point[2] === 1);
            if (!hasPoint) {
                FJMessageStore.addMessage(FJLocalStore._('please-select-the-objects-you-want-to-keep'), 'error');
                return;
            }

            // 生成不重复的时间戳字符串
            _curCustomRemoverEventId = `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
            let curEventID = _curCustomRemoverEventId;
            _curEventId = null;
            const editVideoInfo = getState().videoBgRemover.editVideoInfo;
            const { creditNumber, freeNumCreation } = getState().common;
            const canCredit = creditNumber >= editVideoInfo.duration * VIDEO_REMOVE_BG_USE_CREDIT;
            const useFree = !canCredit && freeNumCreation > 0;

            dispatch(setSliceCustomProgressThumbnailUrl(null));
            __createThumbnail();
            dispatch(setSliceCustomRemoverProgress(0));
            dispatch(setSliceCustomRemoverRoughlyAllTime(editVideoInfo.duration * 8));
            dispatch(setSliceCustomRemoverStatus(FJConstant.START));

            if (useFree && editVideoInfo.duration > 6) {
                // 免费 只能使用6s的视频
                FJMessageStore.addMessage(FJLocalStore._('free-video-length-limit'), 'error');
                dispatch(setSliceCustomRemoverStatus(FJConstant.DEFAULT));
                return;
            }

            if (!canCredit && !useFree) {
                dispatch(FJActionModal.showUpgradeModalAction());
                dispatch(setSliceCustomRemoverStatus(FJConstant.DEFAULT));
                return;
            }

            const userSpaceType = await FJUtil.checkUserSpace({
                errorCallback: () => {
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-remove-background'), 'error');
                },
            });
            if (userSpaceType > 0) {
                dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                dispatch(setSliceCustomRemoverStatus(FJConstant.DEFAULT));
                return;
            }

            try {
                // 视频上传 s3
                const file = FJVideoRemoveVideoManageSingleton.getSource();
                if (!file) {
                    __errorCallback();
                    return;
                }

                if (!_customEventIsContinue(curEventID)) {
                    _curCustomRemoverEventId === null && __cancelCallback();
                    return;
                }

                const key = await FJUtil.hashEncode(file);
                if (!key) {
                    __errorCallback();
                    return;
                }

                if (!_customEventIsContinue(curEventID)) {
                    _curCustomRemoverEventId === null && __cancelCallback();
                    return;
                }

                const fileExtension = file.name.split('.').pop();
                const s3Url = FJConfig.originalImageKey + `${key}.${fileExtension}`;

                const res = await FJImageStore.upLoadFileToS3Async(file, s3Url);
                if (!res) {
                    __errorCallback();
                    return;
                }

                if (!_customEventIsContinue(curEventID)) {
                    _curCustomRemoverEventId === null && __cancelCallback();
                    return;
                }

                const maskBlob = await FJVideoRemoveVideoManageSingleton.getMaskBlob();
                const s3MaskUrl = FJConfig.videoRemoveBgMaskS3key + `${key}.png`;
                const maskRes = await FJImageStore.upLoadFileToS3Async(maskBlob, s3MaskUrl);

                if (!maskRes) {
                    __errorCallback();
                    return;
                }

                if (!_customEventIsContinue(curEventID)) {
                    _curCustomRemoverEventId === null && __cancelCallback();
                    return;
                }

                const data = await FJVideoRemoveVideoManageSingleton.startTrack(
                    FJS3Config.S3_SERVER_HOST + s3Url,
                    FJS3Config.S3_SERVER_HOST + s3MaskUrl,
                    __websocketCallback,
                );
                if (!data || data.code !== 200 || !data.data.event_id) {
                    __errorCallback();
                    return;
                }
                _curEventId = data.data.event_id;

                const tool = FJUtil.getToolName();
                FJUtil.eaLog('ai tool start generating', {
                    'credit&free': useFree ? 'free' : 'credit',
                    tool,
                });

                if (!_customEventIsContinue(curEventID)) {
                    await dispatch(this.cancelTaskAction(_curEventId));
                    _curEventId = null;
                    _curCustomRemoverEventId === null && __cancelCallback();
                    return;
                }

                dispatch(FJActionCommon.updateFreezeInfoAction());

                // 上传视频缩略图
                const thumbnailBlob = await FJVideoRemoveVideoManageSingleton.getThumbnailBlob();
                const s3ThumbnailUrl = FJConfig.resultCoverKey + `${_curEventId}.png`;
                const thumbnailRes = await FJImageStore.upLoadFileToS3Async(thumbnailBlob, s3ThumbnailUrl);

                if (!thumbnailRes) {
                    await dispatch(FJActionCommon.cancelTaskAction(_curEventId));
                    dispatch(FJActionCommon.updateFreezeInfoAction());
                    _curEventId = null;
                    _curCustomRemoverEventId === null && __errorCallback();
                    return;
                }

                if (!_customEventIsContinue(curEventID)) {
                    await dispatch(this.cancelTaskAction(_curEventId));
                    dispatch(FJActionCommon.updateFreezeInfoAction());
                    _curEventId = null;
                    _curCustomRemoverEventId === null && __cancelCallback();
                    return;
                }

                // 3. 轮询任务状态
                const __callback = data => {
                    const { type, waitingEndTime } = data;

                    if (type === FJConstant.SUCCESS) {
                        const finishTaskCreationList = data.finishTaskCreationList;
                        __successCallback(finishTaskCreationList);

                        let _endTime = new Date().getTime();
                        const generatingDuration = FJUtil.getTimeDiff(waitingEndTime, _endTime);

                        FJUtil.eaLog('ai video bg remover success', {
                            'generating duration': generatingDuration,
                            type: 'auto',
                            'credit&free': useFree ? 'free' : 'credit',
                            'video duration': FJUtil.getTimeDiff(0, editVideoInfo.duration * 1000),
                        });

                        FJUtil.eaLog('ai tool generate success', {
                            tool: FJUtil.getToolName(),
                            'credit&free': useFree ? 'free' : 'credit',
                        });
                    }

                    if (type === FJConstant.ERROR) {
                        __errorCallback();
                    }
                };

                dispatch(this._startCustomRemoverProgress());
                dispatch(setSliceCustomRemoverStatus(FJConstant.GENERATING));
                dispatch(
                    FJActionCommon.pollingTaskAction([_curEventId], {
                        callback: __callback,
                    }),
                );
            } catch (error) {
                console.log(error);
                __errorCallback();
            }
        };
    },

    /**
     * @desc 取消任务
     * @returns {Function}
     */
    cancelTaskAction: function (taskId) {
        return async dispatch => {
            try {
                taskId && (await FJNetworkStore.cancelTask(taskId));
            } catch (e) {
                FJMessageStore.addMessage(FJLocalStore._('cancel-to-delete-please-try-again'), 'error');
            } finally {
                dispatch(setSliceCreationListAction([]));
            }
        };
    },
    /**
     * @desc 取消自定义去背景
     * @returns {Function}
     */
    cancelCustomRemoverAction: function () {
        return async dispatch => {
            _curCustomRemoverEventId = null;
            _curEventId && (await dispatch(FJActionCommon.cancelTaskAction(_curEventId)));
            dispatch(this._endCustomRemoverProgress());
            dispatch(setSliceCustomRemoverProgress(0));
            dispatch(setSliceCustomRemoverStatus(FJConstant.DEFAULT));
            setTimeout(() => {
                FJVideoRemoveVideoManageSingleton.draw();
            }, 100);
        };
    },

    /**
     * @desc 取消自动去背景
     * @returns {Function}
     */
    cancelAutoRemoverAction: function () {
        return async dispatch => {
            _curAutoRemoverEventId = null;
            await dispatch(this.cancelTaskAction(_autoRemoveBgEventId));
            dispatch(this._endAutoRemoverProgress());
            dispatch(setSliceAutoRemoverProgress(0));
            const videoInfo = FJVideoRemoveAutoManageSingleton.getSourceInfo();
            dispatch(setSliceAutoEditVideoInfo(videoInfo));

            dispatch(setSliceAutoEditVideoIsUploading(false));
            dispatch(setSliceAutoRemoverStatus(videoInfo ? FJConstant.SUCCESS : FJConstant.DEFAULT));
            setTimeout(() => {
                FJVideoRemoveAutoManageSingleton.draw();
            }, 100);
        };
    },
    /**
     * @desc 根据核心数据更新 reducer 中的数据
     * @returns {Function}
     */
    _updateTrackletsByCoreData: function () {
        return async dispatch => {
            const tracklets = FJVideoRemoveVideoManageSingleton.getTracklets();
            dispatch(setSliceTracklets(tracklets));
            if (tracklets.length > 0) {
                FJVideoRemoveVideoManageSingleton.setTrackletObjectId(tracklets[0].id);
            }
        };
    },

    /**
     * @desc 设置自定义删除背景步骤
     * @param {Number} step
     * @returns {Function}
     */
    setCustomRemoverStepAction: function (step, updateVideoThumbnail = true) {
        return async dispatch => {
            dispatch(setSliceCustomRemoverStep(step));

            if (step === 0) {
                updateVideoThumbnail && (await dispatch(this.updateVideoThumbnailAction()));
                await FJVideoRemoveVideoManageSingleton.updateCustomObjectPreviewCanvas();
            }
            dispatch(this.seekAction(0, 'custom'));
        };
    },

    /**
     * @desc 返回自定义删除背景步骤
     * @returns {Function}
     */
    goBackCustomRemoverAction: function () {
        return async dispatch => {
            dispatch(this.pauseAction());

            const __loadingSource = async () => {
                try {
                    dispatch(setSliceCustomRemoverStatus(FJConstant.LOADING));
                    await FJVideoRemoveVideoManageSingleton.reloadSource();
                    const videoInfo = FJVideoRemoveVideoManageSingleton.getSourceInfo();
                    dispatch(setSliceTotalTime(videoInfo.duration));
                    dispatch(
                        setSliceEditVideoInfo({
                            width: videoInfo.width,
                            height: videoInfo.height,
                        }),
                    );
                    FJVideoRemoveVideoManageSingleton.seek(0);
                    dispatch(setSliceCurrentTime(0));
                    dispatch(this._updateTrackletsByCoreData());
                    dispatch(setSliceCustomRemoverStatus(FJConstant.DEFAULT));

                    dispatch(this.updateVideoThumbnailAction());
                } catch (error) {
                    dispatch(setSliceCustomRemoverStatus(FJConstant.SOURCE_LOADING_ERROR));
                }
            };

            const __back = async () => {
                dispatch(this.removeBgAction());
                dispatch(setSliceCustomExportFormate(FJVideoRemoveBgDataConfig.FORMATE_LIST[0]));
                dispatch(this.setCustomRemoverStepAction(CUSTOM_REMOVE_BG_STEP_LIST[0]));
                const sourceStatus = FJVideoRemoveVideoManageSingleton.getSourceStatus();
                if (sourceStatus !== FJConstant.SUCCESS) {
                    __loadingSource();
                }
            };

            const showVideoRemoveBgGotoBackModal = localStorage.getItem('showVideoRemoveBgGotoBackModal');
            if (showVideoRemoveBgGotoBackModal) {
                __back();
                return;
            }

            const __goIt = isApply => {
                if (isApply) {
                    localStorage.setItem('showVideoRemoveBgGotoBackModal', 'true');
                }
                __back();
            };

            dispatch(
                FJActionModal.showWarningModalAction({
                    title: FJLocalStore._('go-back-warning-title'),
                    content: FJLocalStore._('go-back-warning-content'),
                    isShowApplyBtn: true,
                    checkBoxText: FJLocalStore._('don-t-show-again'),
                    footerDates: [
                        {
                            btnType: FJButtonType.GRADIENT,
                            btnText: FJLocalStore._('yes'),
                            btnCallback: __goIt,
                        },
                        {
                            btnType: FJConstant.CANCEL,
                            btnText: FJLocalStore._('cancel'),
                            btnCallback: null,
                        },
                    ],
                }),
            );
        };
    },

    /**
     * @desc 初始化 flexClip 背景图片列表

     * @returns {Function}
     */
    initFlexClipBackgroundData: function () {
        return async (dispatch, getState) => {
            const flexClipBgLoadStatus = getState().videoBgRemover.flexClipBgLoadStatus;
            if (flexClipBgLoadStatus === FJConstant.SUCCESS || flexClipBgLoadStatus === FJConstant.LOADING) {
                return;
            }

            try {
                dispatch(setSliceFlexClipBgLoadStatus(FJConstant.LOADING));
                const response = await fetch(FJConfig.backgroundPhotoListJsonPath);
                const backgroundPhotoList = await response.json();

                dispatch(setSliceBackgroundPhotoList(backgroundPhotoList));
                dispatch(setSliceFlexClipBgLoadStatus(FJConstant.SUCCESS));
            } catch (error) {
                dispatch(setSliceFlexClipBgLoadStatus(FJConstant.ERROR));
            }
        };
    },

    /**
     * @desc 设置背景颜色
     * @param {string} color
     * @returns
     */
    setBackgroundColorAction: function (color, changeType = FJConstant.CHANGE_END) {
        return async (dispatch, getState) => {
            const curMenuIndex = getState().videoBgRemover.curMenuIndex;
            if (curMenuIndex === 1) {
                FJVideoRemoveAfterManageSingleton.setBackgroundColor(color);
                FJVideoRemoveAfterManageSingleton.draw();
            } else {
                FJVideoRemoveAutoManageSingleton.setBackgroundColor(color);
                FJVideoRemoveAutoManageSingleton.draw();
            }

            dispatch(setSliceCurBgColor(color));
            dispatch(setSliceCurSelectBgData(null));
        };
    },

    //#region 背景图片使用中列表
    /**
     * @desc 添加背景图片使用中列表
     * @param {Object} item
     * @returns
     */
    addBgUsePhotoLoadingList: function (item) {
        return async (dispatch, getState) => {
            const newList = [...getState().videoBgRemover.bgUsePhotoLoadingList, item];
            dispatch(setSliceBgUsePhotoLoadingList(newList));
        };
    },

    /**
     * @desc 移除背景图片使用中列表
     * @param {Object} item
     * @returns
     */
    removeBgUsePhotoLoadingList: function (item) {
        return async (dispatch, getState) => {
            const newList = getState().videoBgRemover.bgUsePhotoLoadingList.filter(i =>
                i.id ? i.id !== item.id : i.key !== item.key,
            );
            dispatch(setSliceBgUsePhotoLoadingList(newList));
        };
    },
    //#endregion

    /**
     * @desc 设置背景图片
     * @param {Object} item
     * @returns
     */
    setBackgroundImageAction: function (item = {}, isAiPhoto = false) {
        return async (dispatch, getState) => {
            const { url } = item;

            if (!url) return;

            const curMenuIndex = getState().videoBgRemover.curMenuIndex;
            const downloadUrl =
                !isAiPhoto && !item.isCustomUpload
                    ? FJConfig.serverPath + FJConfig.flexClipBgPhotoBaseUrl + item.name
                    : url;

            const key = isAiPhoto || item.isCustomUpload ? item.id : item.name;
            const backgroundInfo = {
                url: downloadUrl,
                isAiPhoto: isAiPhoto,
                key,
            };
            dispatch(this.addBgUsePhotoLoadingList(backgroundInfo));

            try {
                if (curMenuIndex === 1) {
                    await FJVideoRemoveAfterManageSingleton.setBackgroundImage(backgroundInfo);
                    FJVideoRemoveAfterManageSingleton.draw();
                } else {
                    await FJVideoRemoveAutoManageSingleton.setBackgroundImage(backgroundInfo);
                    FJVideoRemoveAutoManageSingleton.draw();
                }

                dispatch(this._updateCommonData());
            } catch (error) {
                FJMessageStore.addMessage(FJLocalStore._('failed-to-load-image-please-try-again'), 'error');
            } finally {
                dispatch(this.removeBgUsePhotoLoadingList(backgroundInfo));
            }
        };
    },

    /**
     * @desc 上传背景
     * @returns
     */
    uploadBgAction: function (file) {
        return async (dispatch, getState) => {
            const flexClipBgLoadStatus = getState().videoBgRemover.flexClipBgLoadStatus;
            if (flexClipBgLoadStatus === FJConstant.LOADING) return;

            const { status, errorType } = _judgeFile(file);
            if (!status) {
                _showTipByErrorType(errorType);
                return;
            }

            const fileId = await FJUtil.hashEncode(file);
            const customUploadBgFileList = getState().videoBgRemover.customUploadBgFileList;
            const sameFile = customUploadBgFileList.find(item => item.id === fileId);

            if (sameFile) {
                FJMessageStore.addMessage(FJLocalStore._('file-already-exists-please-select-other-files'), 'error');
                return;
            }

            const imgData = await FJCompressedImageStore.compressImageByFile(file);

            if (!imgData) {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
                return;
            }
            imgData.id = fileId;

            dispatch(setSliceCustomUploadBgFileList([imgData, ...customUploadBgFileList]));

            dispatch(
                this.setBackgroundImageAction({
                    url: imgData.src,
                    isCustomUpload: true,
                    id: fileId,
                }),
            );
        };
    },

    /**
     * @desc 移除背景
     * @returns
     */
    removeBgAction: function () {
        return async (dispatch, getState) => {
            const curMenuIndex = getState().videoBgRemover.curMenuIndex;
            if (curMenuIndex === 1) {
                FJVideoRemoveAfterManageSingleton.clearBackground();
                FJVideoRemoveAfterManageSingleton.draw();
            } else {
                FJVideoRemoveAutoManageSingleton.clearBackground();
                FJVideoRemoveAutoManageSingleton.draw();
            }
            dispatch(setSliceCurBgColor(''));
            dispatch(setSliceCurSelectBgData(null));
        };
    },

    /**
     * @desc 移除完整视频背景
     * @returns
     */
    removeAllAction: function () {
        return async dispatch => {
            dispatch(this.pauseAction());
            _showGetCreditsModal = true;
            dispatch(FJActionModal.showUpgradeModalAction());

            FJUtil.eaLog('ai video remove full video click');
        };
    },

    /**
     * @desc 积分更新后视频移除背景数据
     * @returns {Function}
     */
    updateGetCreditsAfterRemoveAllAction: function () {
        return async (dispatch, getState) => {
            if (FJConfig.appType !== FJAppConstant.VIDEO_REMOVE_BG || !_showGetCreditsModal) return;
            _showGetCreditsModal = false;
            const curMenuIndex = getState().videoBgRemover.curMenuIndex;

            if (curMenuIndex === 1) {
                dispatch(setSliceCustomRemoverIsTrimVideo(false));
                setTimeout(() => {
                    dispatch(this.uploadCustomVideoAction(_fullVideoSource.source));
                }, 200);
            } else {
                dispatch(setSliceAutoRemoverIsTrimVideo(false));
                setTimeout(() => {
                    dispatch(this.uploadAutoEditVideoAction(_autoRemoverFullVideoSource));
                }, 200);
            }
        };
    },

    /**
     * @desc 检查任务状态
     * @returns {Function}
     */
    _checkTaskStatus: async function (successCallbackData, eventId) {
        const result = await FJNetworkStore.getTaskState(eventId);
        if (!result) {
            return 'error';
        }

        switch (result.job_state) {
            case 'succeeded':
                if (result.out_put) {
                    const list = result.out_put;
                    const data = await FJUtil.parseList(list, {
                        prompt,
                        type: FJConstant.CREATIONS,
                        isUploadWaterMark: FJConfig.appType !== FJAppConstant.FACE_SWAP,
                    });
                    successCallbackData && successCallbackData(data);
                }
                return 'succeeded';
            case 'waiting':
            case 'processing':
                return 'processing';
            case 'failed':
            case 'canceled':
                return 'failed';
            default:
                return 'error';
        }
    },

    /**
     * @desc 重试自定义删除背景
     * @returns {Function}
     */
    retryCustomRemoverAction: function () {
        return async (dispatch, getState) => {
            let successCallbackData = null;

            // 重新创建新任务
            const __reloadTask = async () => {
                dispatch(this.startTrackAction());
            };

            // 任务成功回调
            const __successCallback = async callbackData => {
                if (!callbackData) return;
                const item = callbackData[0];

                dispatch(FJActionCommon.setHeaderTabIndexAction(0));
                await FJVideoRemoveAfterManageSingleton.setSource(item.videoUrl);
                dispatch(this.setCustomRemoverStepAction(CUSTOM_REMOVE_BG_STEP_LIST[1]));
                dispatch(setSliceCustomRemoverStatus(FJConstant.DEFAULT));
                dispatch(this._endCustomRemoverProgress());
                dispatch(setSliceCustomRemoverProgress(0));
                _customPlayVideoSource = true;
            };

            const __errorCallback = () => {
                dispatch(this.setCustomRemoverStepAction(CUSTOM_REMOVE_BG_STEP_LIST[0]));
                dispatch(setSliceCustomRemoverStatus(FJConstant.ERROR));
                dispatch(this._endCustomRemoverProgress(false));
            };

            // 重新处理当前任务
            const __processTask = async () => {
                const __callback = data => {
                    const { type } = data;

                    if (type === FJConstant.SUCCESS) {
                        const finishTaskCreationList = data.finishTaskCreationList;
                        __successCallback(finishTaskCreationList);
                    }

                    if (type === FJConstant.ERROR) {
                        __errorCallback();
                    }
                };

                const curProgress = getState().videoBgRemover.customRemoverProgress;
                dispatch(this._startCustomRemoverProgress(curProgress));
                dispatch(setSliceCustomRemoverStatus(FJConstant.GENERATING));
                dispatch(
                    FJActionCommon.pollingTaskAction([_curEventId], {
                        callback: __callback,
                    }),
                );
            };

            if (!_curEventId) {
                __reloadTask();
            } else {
                const __checkTaskStatus = async () => {
                    const result = await FJNetworkStore.getTaskState(_curEventId);
                    if (!result) {
                        return 'error';
                    }

                    switch (result.job_state) {
                        case 'succeeded':
                            if (result.out_put) {
                                const list = result.out_put;
                                successCallbackData = await FJUtil.parseList(list, {
                                    prompt,
                                    type: FJConstant.CREATIONS,
                                    isUploadWaterMark: FJConfig.appType !== FJAppConstant.FACE_SWAP,
                                });
                            }
                            return 'succeeded';
                        case 'waiting':
                        case 'processing':
                            return 'processing';
                        case 'failed':
                        case 'canceled':
                            return 'failed';
                        default:
                            return 'error';
                    }
                };

                try {
                    const taskStatus = await __checkTaskStatus();
                    switch (taskStatus) {
                        case 'succeeded':
                            __successCallback(successCallbackData);
                            break;
                        case 'processing':
                            __processTask();
                            break;
                        case 'failed':
                            __reloadTask();
                            break;
                        case 'error':
                            __errorCallback();
                            break;
                    }
                } catch (error) {
                    __errorCallback();
                }
            }
        };
    },

    /**
     * @desc 重试自动删除背景
     * @returns {Function}
     */
    retryAutoRemoverAction: function () {
        return async (dispatch, getState) => {
            let successCallbackData = null;

            const __reloadTask = async () => {
                if (!_autoRemoverVideoSource) return;
                dispatch(this.uploadAutoEditVideoAction(_autoRemoverVideoSource));
            };

            const __successCallback = async callbackData => {
                dispatch(this.removeBgAction());
                const data = callbackData[0];
                await FJVideoRemoveAutoManageSingleton.setSource(data.videoUrl);
                const videoMetadata = FJVideoRemoveAutoManageSingleton.getSourceInfo();
                dispatch(this.seekAction(0));

                dispatch(setSliceAutoRemoverStatus(FJConstant.SUCCESS));
                dispatch(this._endAutoRemoverProgress());

                dispatch(
                    setSliceAutoEditVideoInfo({
                        width: videoMetadata.width,
                        height: videoMetadata.height,
                    }),
                );
                _autoPlayVideoSource = true;
            };

            const __errorCallback = () => {
                dispatch(setSliceAutoRemoverStatus(FJConstant.ERROR));
                dispatch(this._endAutoRemoverProgress(false));
            };

            const __processTask = async () => {
                const __callback = data => {
                    const { type } = data;

                    if (type === FJConstant.SUCCESS) {
                        const finishTaskCreationList = data.finishTaskCreationList;
                        __successCallback(finishTaskCreationList);
                    }

                    if (type === FJConstant.ERROR) {
                        __errorCallback();
                    }
                };

                const curProgress = getState().videoBgRemover.autoRemoverProgress;
                dispatch(this._startAutoRemoverProgress(curProgress));
                dispatch(setSliceAutoRemoverStatus(FJConstant.GENERATING));
                dispatch(
                    FJActionCommon.pollingTaskAction([_autoRemoveBgEventId], {
                        callback: __callback,
                    }),
                );
            };

            if (!_autoRemoveBgEventId) {
                __reloadTask();
            } else {
                try {
                    const status = await this._checkTaskStatus(result => {
                        if (result) {
                            successCallbackData = result;
                        }
                    }, _autoRemoveBgEventId);

                    switch (status) {
                        case 'succeeded':
                            __successCallback(successCallbackData);
                            break;
                        case 'processing':
                            __processTask();
                            break;
                        case 'failed':
                            __reloadTask();
                            break;
                    }
                } catch (error) {
                    __errorCallback();
                }
            }
        };
    },

    /**
     * @desc 打开覆盖正在编辑提示
     * @param {*} cancelCallback
     * @param {*} applyCallback
     * @returns
     */
    _openMessageModel: function (cancelCallback, applyCallback) {
        return async dispatch => {
            dispatch(
                FJActionModal.showWarningModalAction({
                    title: FJLocalStore._('upload-again-and-the-current-changes-will-be-lost'),
                    content: FJLocalStore._('upload-again-and-the-current-changes-will-be-lost-video-desc'),
                    footerDates: [
                        {
                            btnType: FJConstant.SUBMIT,
                            btnText: FJLocalStore._('upload'),
                            btnCallback: async () => {
                                applyCallback && applyCallback();
                            },
                        },
                        {
                            btnType: FJConstant.CANCEL,
                            btnText: FJLocalStore._('cancel'),
                            btnCallback: () => {
                                cancelCallback && cancelCallback();
                            },
                        },
                    ],
                    closeCallback: cancelCallback,
                }),
            );
        };
    },

    /**
     * @desc 自动编辑视频移除背景历史
     * @param {Object} data
     * @param {Function} callback
     * @returns {Function}
     */
    _autoEditVideoRemoveBgHistoryAction: function (data, callback) {
        return async dispatch => {
            try {
                const { videoUrl, width, height } = data;

                dispatch(FJActionCommon.setHeaderTabIndexAction(0));
                dispatch(this.changeCurMenuIndexAction(0));
                dispatch(this.autoCancelExportVideoAction());
                dispatch(setSliceAutoRemoverStatus(FJConstant.LOADING));
                dispatch(
                    setSliceAutoEditVideoInfo({
                        width: width,
                        height: height,
                    }),
                );
                FJVideoRemoveAutoManageSingleton.clearAll();
                await FJVideoRemoveAutoManageSingleton.setSource(videoUrl);
                const videoInfo = FJVideoRemoveAutoManageSingleton.getSourceInfo();

                dispatch(
                    setSliceAutoEditVideoInfo({
                        width: videoInfo.width,
                        height: videoInfo.height,
                        duration: videoInfo.duration,
                    }),
                );
                dispatch(setSliceTotalTime(videoInfo.duration));
                callback && callback();
                dispatch(setSliceAutoExportFormate(FJVideoRemoveBgDataConfig.FORMATE_LIST[0]));
                dispatch(setSliceAutoRemoverStatus(FJConstant.SUCCESS));
                dispatch(this._updateCommonData());
                dispatch(this.seekAction(0));
            } catch (error) {
                dispatch(setSliceAutoRemoverStatus(FJConstant.SOURCE_LOADING_ERROR));
                callback && callback();
            }
        };
    },

    /**
     * @desc 自定义编辑视频移除背景历史
     * @param {Object} data
     * @param {Function} callback
     * @returns {Function}
     */
    _customEditVideoRemoveBgHistoryAction: function (data, callback) {
        return async dispatch => {
            try {
                const { videoUrl, originalUrl, width, height } = data;

                dispatch(FJActionCommon.setHeaderTabIndexAction(0));
                dispatch(this.changeCurMenuIndexAction(1));
                dispatch(this.cancelExportVideoAction());
                dispatch(
                    setSliceEditVideoInfo({
                        width: width,
                        height: height,
                    }),
                );
                dispatch(setSliceCustomRemoverStatus(FJConstant.LOADING));

                // 第一步设置视频源初始化
                FJVideoRemoveVideoManageSingleton.clearAll();
                FJVideoRemoveVideoManageSingleton.setSourceUrl(originalUrl);
                dispatch(this._updateTrackletsByCoreData());

                // 第二步初始化
                FJVideoRemoveAfterManageSingleton.clearAll();
                await FJVideoRemoveAfterManageSingleton.setSource(videoUrl);
                const videoMetadata = FJVideoRemoveAfterManageSingleton.getSourceInfo();

                dispatch(
                    setSliceEditVideoInfo({
                        width: videoMetadata.width,
                        height: videoMetadata.height,
                        duration: videoMetadata.duration,
                    }),
                );
                dispatch(setSliceTotalTime(videoMetadata.duration));
                callback && callback();
                dispatch(this._updateCommonData());
                dispatch(setSliceCustomExportFormate(FJVideoRemoveBgDataConfig.FORMATE_LIST[0]));
                dispatch(setSliceCustomRemoverStatus(FJConstant.DEFAULT));
                dispatch(this.seekAction(0));
            } catch (error) {
                dispatch(setSliceCustomRemoverStatus(FJConstant.SOURCE_LOADING_ERROR));
                callback && callback();
            }
        };
    },

    /**
     * @desc 编辑视频移除背景历史
     * @param {Object} data
     * @param {Function} callback
     * @returns {Function}
     */
    editVideoRemoveBgHistoryAction: function (data, callback, options = {}) {
        return async (dispatch, getState) => {
            const { isCustomRemoveBg = true } = data;

            const __customRemoveUse = async () => {
                dispatch(this._customEditVideoRemoveBgHistoryAction(data, callback));
            };

            const __autoRemoveUse = async () => {
                dispatch(this._autoEditVideoRemoveBgHistoryAction(data, callback));
            };

            const curSelectBgData = getState().videoBgRemover.curSelectBgData;
            const curBgColor = getState().videoBgRemover.curBgColor;

            const { position = 'history' } = options;
            FJUtil.eaLog('ai video remove edit click', {
                position,
                mode: isCustomRemoveBg ? 'custom' : 'auto',
            });
            callback && callback();
            if (isCustomRemoveBg) {
                const customRemoverStatus = getState().videoBgRemover.customRemoverStatus;
                if (
                    customRemoverStatus === FJConstant.LOADING ||
                    customRemoverStatus === FJConstant.GENERATING ||
                    customRemoverStatus === FJConstant.START
                ) {
                    FJMessageStore.addMessage(FJLocalStore._('generation-task-already-exists'), 'error');
                    callback && callback();
                    return;
                }

                const customRemoverStep = getState().videoBgRemover.customRemoverStep;

                if (customRemoverStep === 1 && (curSelectBgData !== null || curBgColor !== '')) {
                    dispatch(this.setBackgroundImageAction(curSelectBgData, true));
                    dispatch(
                        this._openMessageModel(
                            () => {
                                callback && callback();
                            },
                            () => {
                                __customRemoveUse();
                            },
                        ),
                    );
                } else {
                    __customRemoveUse();
                }
            } else {
                const autoRemoverStatus = getState().videoBgRemover.autoRemoverStatus;

                if (
                    autoRemoverStatus === FJConstant.LOADING ||
                    autoRemoverStatus === FJConstant.GENERATING ||
                    autoRemoverStatus === FJConstant.START
                ) {
                    FJMessageStore.addMessage(FJLocalStore._('generation-task-already-exists'), 'error');
                    callback && callback();
                    return;
                }

                const autoEditVideoInfo = getState().videoBgRemover.autoEditVideoInfo;

                if (autoEditVideoInfo && (curSelectBgData !== null || curBgColor !== '')) {
                    dispatch(
                        this._openMessageModel(
                            () => {
                                callback && callback();
                            },
                            () => {
                                __autoRemoveUse();
                            },
                        ),
                    );
                } else {
                    __autoRemoveUse();
                }
            }
        };
    },

    /**
     * @desc 重新加载自动去背景源
     * @returns {Function}
     */
    reloadAutoRemoveSourceAction: function () {
        return async dispatch => {
            dispatch(setSliceAutoRemoverStatus(FJConstant.LOADING));
            try {
                await FJVideoRemoveAutoManageSingleton.reloadSource();
                const videoInfo = FJVideoRemoveAutoManageSingleton.getSourceInfo();

                dispatch(
                    setSliceAutoEditVideoInfo({
                        width: videoInfo.width,
                        height: videoInfo.height,
                        duration: videoInfo.duration,
                    }),
                );
                dispatch(setSliceTotalTime(videoInfo.duration));
                dispatch(setSliceAutoExportFormate(FJVideoRemoveBgDataConfig.FORMATE_LIST[0]));
                dispatch(setSliceAutoRemoverStatus(FJConstant.SUCCESS));
                dispatch(this._updateCommonData());
                dispatch(this.seekAction(0));
            } catch (error) {
                dispatch(setSliceAutoRemoverStatus(FJConstant.SOURCE_LOADING_ERROR));
            }
        };
    },

    /**
     * @desc 重新加载自定义去背景源
     * @returns {Function}
     */
    reloadCustomRemoveSourceAction: function () {
        return async (dispatch, getState) => {
            dispatch(setSliceCustomRemoverStatus(FJConstant.LOADING));
            const customRemoverStep = getState().videoBgRemover.customRemoverStep;

            try {
                if (customRemoverStep === 1) {
                    await FJVideoRemoveAfterManageSingleton.reloadSource();
                    const videoMetadata = FJVideoRemoveAfterManageSingleton.getSourceInfo();

                    dispatch(
                        setSliceEditVideoInfo({
                            width: videoMetadata.width,
                            height: videoMetadata.height,
                            duration: videoMetadata.duration,
                        }),
                    );
                    dispatch(setSliceTotalTime(videoMetadata.duration));
                    dispatch(this._updateCommonData());
                    dispatch(setSliceCustomExportFormate(FJVideoRemoveBgDataConfig.FORMATE_LIST[0]));
                    dispatch(setSliceCustomRemoverStatus(FJConstant.DEFAULT));
                    dispatch(this.seekAction(0));
                } else {
                    await FJVideoRemoveVideoManageSingleton.reloadSource();
                    dispatch(setSliceCustomRemoverStatus(FJConstant.DEFAULT));
                    const sourceInfo = FJVideoRemoveVideoManageSingleton.getSourceInfo();
                    const editDuration = sourceInfo.duration;
                    dispatch(setSliceTotalTime(editDuration));
                    dispatch(
                        setSliceEditVideoInfo({
                            width: sourceInfo.width,
                            height: sourceInfo.height,
                            duration: editDuration,
                        }),
                    );
                    // TODO : 不使用 this.seekAction(0) 而是使用 FJVideoRemoveVideoManageSingleton.seek(0)
                    // 防止这个时候在自动去背景而导致 seek 没有执行 导致后续界面渲染空白
                    FJVideoRemoveVideoManageSingleton.seek(0);
                    dispatch(setSliceCurrentTime(0));
                    dispatch(this._updateTrackletsByCoreData());
                    dispatch(this.updateVideoThumbnailAction());
                }
            } catch (error) {
                dispatch(setSliceCustomRemoverStatus(FJConstant.SOURCE_LOADING_ERROR));
            }
        };
    },

    /**
     * @desc 更新自动去背景、自定义去背景通用数据
     * @param {Object} data
     * @returns {Function}
     */
    _updateCommonData: function () {
        return async (dispatch, getState) => {
            const curMenuIndex = getState().videoBgRemover.curMenuIndex;
            const customRemoverStep = getState().videoBgRemover.customRemoverStep;
            const autoRemoverStatus = getState().videoBgRemover.autoRemoverStatus;

            let backgroundInfo = null;
            let currentTime = 0;
            let totalTime = 0;
            if (curMenuIndex === 1) {
                if (customRemoverStep !== CUSTOM_REMOVE_BG_STEP_LIST[1]) {
                    currentTime = FJVideoRemoveVideoManageSingleton.getCurrentTime();
                    const sourceInfo = FJVideoRemoveVideoManageSingleton.getSourceInfo();
                    totalTime = sourceInfo ? sourceInfo.duration : 0;
                } else {
                    backgroundInfo = FJVideoRemoveAfterManageSingleton.getBackgroundInfo();
                    currentTime = FJVideoRemoveAfterManageSingleton.getCurrentTime();
                    const sourceInfo = FJVideoRemoveAfterManageSingleton.getSourceInfo();
                    totalTime = sourceInfo ? sourceInfo.duration : 0;
                }
            } else {
                if (autoRemoverStatus !== FJConstant.SUCCESS) return;

                backgroundInfo = FJVideoRemoveAutoManageSingleton.getBackgroundInfo();
                currentTime = FJVideoRemoveAutoManageSingleton.getCurrentTime();
                const sourceInfo = FJVideoRemoveAutoManageSingleton.getSourceInfo();
                totalTime = sourceInfo ? sourceInfo.duration : 0;
            }

            if (backgroundInfo) {
                if (backgroundInfo.type === BACKGROUND_TYPE.IMAGE) {
                    dispatch(setSliceCurSelectBgData(backgroundInfo.imageInfo));
                    dispatch(setSliceCurBgColor(''));
                } else if (backgroundInfo.type === BACKGROUND_TYPE.COLOR) {
                    dispatch(setSliceCurBgColor(backgroundInfo.color));
                    dispatch(setSliceCurSelectBgData(null));
                } else {
                    dispatch(setSliceCurSelectBgData(null));
                    dispatch(setSliceCurBgColor(''));
                }
            }

            dispatch(setSliceTotalTime(totalTime));
            dispatch(setSliceCurrentTime(currentTime));
        };
    },

    /**
     * @desc 切换菜单索引
     * @param {number} index
     * @returns {Function}
     */
    changeCurMenuIndexAction: function (index) {
        return async (dispatch, getState) => {
            await dispatch(this.pauseAction());
            dispatch(setSliceCurMenuIndex(index));
            dispatch(this._updateCommonData());

            let isCheckoutHeaderTabIndex = false;
            if (index === 1) {
                const editVideoInfo = getState().videoBgRemover.editVideoInfo;
                if (editVideoInfo) {
                    isCheckoutHeaderTabIndex = true;
                    FJVideoRemoveVideoManageSingleton.updateCustomObjectPreviewCanvas();
                }
            } else {
                const autoEditVideoInfo = getState().videoBgRemover.autoEditVideoInfo;
                if (autoEditVideoInfo) {
                    isCheckoutHeaderTabIndex = true;
                }
            }

            if (isCheckoutHeaderTabIndex) {
                dispatch(FJActionCommon.setHeaderTabIndexAction(0));
            }
        };
    },

    /**
     * @desc 初始化图片去背景项目
     */
    initVideoRemoveBgProjectAction: function () {
        return async dispatch => {
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            if (recIdInfo) {
                const url = location.origin + location.pathname;
                FJUtil.changeLocation(url);
                window.localStorage.removeItem(recId);
                const { fileList, avator } = recIdInfo;

                if (fileList) {
                    const fileInfo = fileList[0]?.info;
                    if (!fileInfo) return;
                    const data = await FJLoadLocalforageStore.getItem(fileList[0].key);
                    const file = new File([data.data], fileInfo.name, { type: fileInfo.type });
                    dispatch(this.uploadAutoEditVideoAction(file));
                } else if (avator) {
                    const blob = await FJUtil.getBlobByUrl(avator);
                    const file = new File([blob], 'video.mp4', { type: 'video/mp4' });
                    dispatch(this.uploadAutoEditVideoAction(file));
                }
            }
        };
    },

    // #region 导出视频

    exportBaseFunction: function (object, onProgress, onComplete, onError, isGif, isTransparent) {
        if (!object) return;

        object.exportVideo({
            onProgress: progress => {
                onProgress && onProgress(progress);
            },
            onComplete: (blob, type) => {
                const fileName = _getFileName() + '.' + type;
                const mimeType = type === 'gif' ? 'image/gif' : 'video/mp4';

                Download(blob, fileName, mimeType);
                onComplete && onComplete(blob, type);
            },

            onError: error => {
                onError && onError(error);
            },

            isGif: isGif,
            isTransparent: isTransparent,
        });
    },

    /**
     * @desc 导出视频
     * @returns {Function}
     */
    exportVideoAction: function () {
        return async (dispatch, getState) => {
            dispatch(this.pauseAction());

            const curExportFormate = getState().videoBgRemover.customExportData.formate;

            const autoExportStatus = getState().videoBgRemover.autoExportData.exportStatus;

            if (autoExportStatus === FJConstant.START) {
                FJMessageStore.addMessage(FJLocalStore._('video-is-already-downloading'), 'error');
                return;
            }

            dispatch(setSliceCustomExportStatus(FJConstant.START));
            dispatch(setSliceCustomExportProgress(0));
            const customIsTrimVideo = getState().videoBgRemover.customRemoverIsTrimVideo;

            const isGif = curExportFormate === 'gif';
            const editVideoInfo = FJVideoRemoveAfterManageSingleton.getSourceInfo();

            FJUtil.eaLog('ai video remove download click', {
                type: 'custom',
                format: isGif ? 'gif' : 'video',
                duration: editVideoInfo ? editVideoInfo.duration : 0,
                crop: customIsTrimVideo,
            });

            const backgroundInfo = FJVideoRemoveAfterManageSingleton.getBackgroundInfo();
            const isTransparent = backgroundInfo.type === BACKGROUND_TYPE.TRANSPARENT;

            if (!isGif && isTransparent) {
                const file = FJVideoRemoveAfterManageSingleton.getSource();
                const fileName = _getFileName() + '.webm';
                const mimeType = 'video/webm';
                Download(file, fileName, mimeType);
                dispatch(setSliceCustomExportProgress(100));
                dispatch(setSliceCustomExportStatus(FJConstant.SUCCESS));
                return;
            }

            this.exportBaseFunction(
                FJVideoRemoveAfterManageSingleton,
                progress => {
                    dispatch(setSliceCustomExportProgress(Math.min(progress, 0.99)));
                },
                () => {
                    dispatch(setSliceCustomExportStatus(FJConstant.SUCCESS));
                },
                () => {
                    dispatch(setSliceCustomExportStatus(FJConstant.ERROR));
                },
                isGif,
                isTransparent,
            );
        };
    },

    /**
     * @desc 取消导出视频
     * @returns {Function}
     */
    cancelExportVideoAction: function () {
        return async dispatch => {
            FJVideoRemoveAfterManageSingleton.cancelExport();
            dispatch(this.exportGoBackAction());
        };
    },

    /**
     * @desc 导出视频返回
     * @returns {Function}
     */
    exportGoBackAction: function (notSetStep = false) {
        return async dispatch => {
            dispatch(setSliceCustomExportStatus(FJConstant.DEFAULT));
            dispatch(setSliceCustomExportProgress(0));
            !notSetStep && dispatch(this.setCustomRemoverStepAction(CUSTOM_REMOVE_BG_STEP_LIST[1]));
        };
    },

    /**
     * @desc 自动导出视频
     * @returns {Function}
     */
    autoExportVideoAction: function () {
        return async (dispatch, getState) => {
            dispatch(this.pauseAction());
            const curExportFormate = getState().videoBgRemover.autoExportData.formate;

            const customExportStatus = getState().videoBgRemover.customExportData.exportStatus;
            if (customExportStatus === FJConstant.START) {
                FJMessageStore.addMessage(FJLocalStore._('video-is-already-downloading'), 'error');
                return;
            }

            dispatch(setSliceAutoExportStatus(FJConstant.START));
            dispatch(setSliceAutoExportProgress(0));
            const autoIsTrimVideo = getState().videoBgRemover.autoRemoverIsTrimVideo;

            const isGif = curExportFormate === 'gif';

            const editVideoInfo = FJVideoRemoveAutoManageSingleton.getSourceInfo();
            FJUtil.eaLog('ai video remove download click', {
                type: 'auto',
                format: isGif ? 'gif' : 'video',
                duration: editVideoInfo ? editVideoInfo.duration : 0,
                crop: autoIsTrimVideo,
            });

            const backgroundInfo = FJVideoRemoveAutoManageSingleton.getBackgroundInfo();
            const isTransparent = backgroundInfo.type === BACKGROUND_TYPE.TRANSPARENT;

            if (!isGif && isTransparent) {
                const file = FJVideoRemoveAutoManageSingleton.getSource();
                const fileName = _getFileName() + '.webm';
                const mimeType = 'video/webm';
                Download(file, fileName, mimeType);
                dispatch(setSliceAutoExportProgress(100));
                dispatch(setSliceAutoExportStatus(FJConstant.SUCCESS));
                return;
            }

            this.exportBaseFunction(
                FJVideoRemoveAutoManageSingleton,
                progress => {
                    dispatch(setSliceAutoExportProgress(Math.min(progress, 0.99)));
                },
                () => {
                    dispatch(setSliceAutoExportStatus(FJConstant.SUCCESS));
                },
                () => {
                    dispatch(setSliceAutoExportStatus(FJConstant.ERROR));
                },
                curExportFormate === 'gif',
                isTransparent,
            );
        };
    },

    /**
     * @desc 自动取消导出视频
     * @returns {Function}
     */
    autoCancelExportVideoAction: function () {
        return async dispatch => {
            FJVideoRemoveAutoManageSingleton.cancelExport();
            dispatch(this.autoExportGoBackAction());
        };
    },

    /**
     * @desc 自动导出视频返回
     * @returns {Function}
     */
    autoExportGoBackAction: function () {
        return async dispatch => {
            dispatch(setSliceAutoExportStatus(FJConstant.DEFAULT));
            dispatch(setSliceAutoExportProgress(0));
        };
    },
    // #endregion
};

export default FJActionVideoRemoveBg;
